import { SideBar } from '../../models/sideBar.model';
import { assets } from './assets.const';

export const accountSideBarConst = {
  MyProfile: 1,
  MyPackages: 2,
  AccountInvoice: 3,
  PaymentMethod: 4,
  ChangePassword: 5,
  ActivityLogs: 6,
  Settings: 7,
  SignOut: 8,
  DeleteAccount: 9
};

export const tutorCounsellorSideBarConst = {
  MyProfile: 1,
  MyAvailability: 2,
  EarningPayroll: 3,
  ChangePassword: 4,
  ActivityLogs: 5,
  Settings: 6,
  SignOut: 7,
  DeleteAccount: 8
};

export const sideBar: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Students',
    path: '/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Tutoring',
    path: '/manage-tutoring/tutors',
    img: assets.tutoringIcon,
    isSubMenu: false
  },
  {
    text: 'Counselling',
    path: '/manage-counselling/counsellors',
    img: assets.counsellingIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources ',
    path: '/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'Calender',
    path: '/calendar',
    img: assets.calendarIcon,
    isSubMenu: false
  },
  {
    text: 'Courses',
    path: '/manage-courses',
    img: assets.coursesIcon,
    isSubMenu: false
  }


];

export const sideBar2: SideBar[] = [
  {
    text: 'Communication',
    path: '/chat',
    img: assets.communicationIcon,
    isSubMenu: false
  },
  {
    text: 'Notifications',
    path: '/manage-notification',
    img: assets.notificationIcon,
    isSubMenu: false
  },
  {
    text: 'help & support',
    path: '/support',
    img: assets.supportIcon,
    isSubMenu: false
  }

];

export const accountSideBar: SideBar[] = [
  {
    text: 'My Profile',
    path: '/my-profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.MyProfile
  },
  {
    text: 'My Packages',
    path: '/manage-tutoring/tutor-package',
    img: assets.profileIcon2,
    isSubMenu: false,
    sideBarId: accountSideBarConst.MyPackages
  },
  {
    text: 'Account & Invoices',
    path: '/my-profile/account-invoice',
    img: assets.profileIcon3,
    isSubMenu: false,
    sideBarId: accountSideBarConst.AccountInvoice
  },
  {
    text: 'Payment Methods',
    path: '/my-profile/payment-method',
    img: assets.paymentMethod,
    isSubMenu: false,
    sideBarId: accountSideBarConst.PaymentMethod
  },
  {
    text: 'Change Password',
    path: '/my-profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ChangePassword
  },
  {
    text: 'Activity logs',
    path: '/my-profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ActivityLogs
  },
  {
    text: 'Settings',
    path: '/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: accountSideBarConst.Settings
  },
  {
    text: 'Sign Out',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.SignOut
  },
  {
    text: 'Delete Account',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.DeleteAccount
  }

];

export const tutorCounsellorSideBar: SideBar[] = [
  {
    text: 'My Profile',
    path: '/tutor/profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyProfile
  },
  {
    text: 'My Availability',
    path: '/tutor/profile/availability',
    img: assets.profileIcon2,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyAvailability
  },
  {
    text: 'Earnings & Payroll',
    path: '/tutor/dashboard/earning',
    img: assets.profileIcon3,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.EarningPayroll
  },
  {
    text: 'Change Password',
    path: '/tutor/profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ChangePassword
  },
  {
    text: 'Activity logs',
    path: '/tutor/profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ActivityLogs
  },
  {
    text: 'Settings',
    path: '/tutor/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.Settings
  },
  {
    text: 'Sign Out',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.SignOut
  },
  {
    text: 'Delete Account',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.DeleteAccount
  }

];


export const settingSideBar: SideBar[] = [
  {
    text: 'About Us',
    path: '/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms & Conditions',
    path: '/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'Privacy Policy',
    path: '/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }

];


export const sideBartutor4: SideBar[] = [
  {
    text: 'About Us',
    path: '/tutor/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms & Conditions',
    path: '/tutor/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'Privacy Policy',
    path: '/tutor/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/tutor/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }


];


export const sideBarTutor1: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/tutor/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Students',
    path: '/tutor/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Calender',
    path: '/tutor/calendar',
    img: assets.calendarIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/tutor/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources',
    path: '/tutor/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'Courses',
    path: '/tutor/manage-courses',
    img: assets.coursesIcon,
    isSubMenu: false
  }


];

export const sideBarTutor2: SideBar[] = [
  {
    text: 'Communication',
    path: '/tutor/chat',
    img: assets.communicationIcon,
    isSubMenu: false
  },
  {
    text: 'Notifications',
    path: '/tutor/manage-notification',
    img: assets.notificationIcon,
    isSubMenu: false
  },
  {
    text: 'help & support',
    path: '/tutor/support',
    img: assets.supportIcon,
    isSubMenu: false
  }
];
